import React from 'react'


function Hero() {
    return (
        <div className='container'>
            <div className=' row text-center p-5 my-5'>
                <h2>Charges</h2>
                <p className='fs-4 text-muted'>List of all charges and taxes</p>
            </div>
            <div className='row text-center p-3 my-5'  style={{ alignItems: 'center', justifyContent: 'center', gap: '5rem' }}>
                <div className='col-2' style={{width: '22%'}}>
                    <img src='media/pricing-0.svg' style={{ width: "250px" }} />
                    <p style={{ fontSize: "25px" }} >Free equity delivery</p>
                    <p  className='text-muted'>All equity delivery investments (NSE, BSE), are absolutely free — ₹ 0 brokerage.</p>
                </div>

                <div className='col-2'  style={{width: '25%'}}>
                    <img src='media/pricing-20.svg' style={{ width: "250px" }} />
                    <p style={{ fontSize: "25px" }} >Intraday and F&O trades</p>
                    <p className='text-muted'>Flat ₹ 20 or 0.03% (whichever is lower) per executed order on intraday trades across equity, currency, and commodity trades. Flat ₹20 on all option trades.</p>
                </div>

                <div className='col-2'  style={{width: '22%'}}>
                    <img src='media/pricing-0.svg' style={{ width: "250px" }} />
                    <p style={{ fontSize: "25px" }} >Free direct MF</p>
                    <p className='text-muted'>All direct mutual fund investments are absolutely free — ₹ 0 commissions & DP charges.</p>
                </div>
                
            </div>
        </div>
    );
}

export default Hero;